import { paginationFragment } from './fragments/pagination';

const fragment = `
  id
  amount
  status
  statusChangeDates
  errorMessage
  note
  paymentVendor
  paymentMethod
  createdAt
  payoutStatus
  payoutErrorMessage
  paymentMethodDetails
  currency
  confirmed
  creditAllowed
  partialRefund
  fullRefund
  user {
    id
    name
    contact {
      id
      name
      email
    }
  }
  home @include(if: $withHome) {
    id
    beds
    baths
    sizeSqft
    totalPrice
    homeUrl
    createdAt
    deletedByUserAt
    singleFamilyHome {
      model {
        id
        name
        imageUrl
        defaultImageUrl
        productType {
          id
          name
        }
      }
      community {
        id
        name
      }
      elevation {
        id
        imageUrl
      }
      isQuickPossession
      quickPossession {
        id
        address
        imageUrl
      }
      isLot
      lot
    }
    multiFamilyHome {
      project {
        id
        name
        address
      }
      unit {
        id
        name
        defaultImageUrl
        address
        buildingModel {
          id
          name
          bedrooms
          bathrooms
          size
        }
      }
    }
  }
  authorizationStatus
  authorizationErrorMessage
`;

export const getDepositQuery = `
  query GetDeposit(
    $id: Int!
    $withHome: Boolean! = false
  ) {
    item: getDeposit(id: $id) {
      ${fragment}
    }
  }
`;

export const listDepositsQuery = `
  query ListDeposits(
    $filter: DepositFilterInput!
    $sort: SortInput
    $page: Int
    $pageSize: Int
    $withHome: Boolean! = false
  ) {
    result: listDeposits(filter: $filter, sort: $sort, page: $page, pageSize: $pageSize) {
      items {
        ${fragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const updateDepositQuery = `
  mutation UpdateDeposit(
    $input: UpdateDepositInput!
    $withHome: Boolean! = false
  ) {
    item: updateDeposit(input: $input) {
      ${fragment}
    }
  }
`;
